module.exports = __webpack_public_path__ + "static/img/circle1.58bf45ba.png";